module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propTitle prop-header hide\">\r\n    <span id=\"textInputSettingTitle\" class=\"prop-label\">")
    ; __append(escapeFn(inputTextSettingsTitle))
    ; __append("</span>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 nopadding-r subsection\"> \r\n        <label class=\"prop-sublabel label-60\">Max Chars</label>\r\n        <div>\r\n            <input type=\"text\" name=\"maxChars\" class=\"label-50\" maxlength=\"5\" value=\"")
    ; __append(escapeFn( maxChars ))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}